export default __webpack_public_path__ + "media/images/features/ja/vege_2-e3bf2da84d7f6bcf812ef2deaec345a2.png";